import PhotoListing_SimplePhotoThumb from '@Components/Listings/PhotoListing_SimplePhotoThumb';
import AdditionalLinks from '@Components/Shared/AdditionalLinks';
import { useWindowSize } from '@Components/Utilities/WindowSize';
import AboutUs from '@Components/Home/AboutUs';
import { bannerAdPositions } from '@Components/Utilities/SandhillsConstants';
import DoubleClickAd from '@Components/Shared/DoubleClick/DoubleClickAd';
import { getBannerAd } from '@Components/Utilities/SandhillsUtility';

const PhotoListingsHomePage = (props) => {
    const windowSize = useWindowSize();

    return (
        <div>
            <div className='main'>
                <div className='container cf photolisting-home-container'>
                    <span className='home-header'>
                        <h1 className='cf'>{props.PageHeader}</h1>
                        <a href={props.ViewAllUrl}><strong>{props.ViewAllText}</strong> <i className='fas fa-arrow-circle-right' aria-hidden='true'></i></a>
                    </span>
                    <div className='clear'></div>
                    {windowSize.isMobile &&
                        <DoubleClickAd
                        {...props.DoubleClickAdCollection}
                        position={bannerAdPositions.Middle}
                        ad={getBannerAd(props.DoubleClickAdCollection?.AdUnits, bannerAdPositions.Middle)}
                        contained
                        />
                    }
                    <div className='home-thumb-container thumb-container'>
                        {props.Listings.map((value, index) =>
                            <PhotoListing_SimplePhotoThumb {...value} Key={index} />)}                              
                    </div>
                    {!windowSize.isMobile &&
                        <DoubleClickAd
                        {...props.DoubleClickAdCollection}
                        position={bannerAdPositions.Middle}
                        ad={getBannerAd(props.DoubleClickAdCollection?.AdUnits, bannerAdPositions.Middle)}
                        contained
                        />
                    }
                    <div className='clear'></div><br />
                    <AdditionalLinks {...props.CategoryLinks} />
                    <div className='clear'></div><br />
                    <AdditionalLinks {...props.ManufacturerLinks} />
                    <section className='about-us-section'>
                        <div className='about-us-outside-container'>
                            <AboutUs {...props.AboutUs} className={windowSize.isMobile ? '' : 'about-us-container'} />
                        </div>
                    </section>
                    <div className='aircraft-disclaimer'>{props.DisclaimerText}</div>
                </div>
            </div>
        </div>
    );
};

export default PhotoListingsHomePage;
global.PhotoListingsHomePage = PhotoListingsHomePage;